import React from 'react'
import PropTypes from 'prop-types'
import { reverse } from 'routes'
import { getMakerName, getBrandName, getModelName } from 'utils/vehicle'

import moment from 'moment'

import './style.scss'

const _parseDate = (date) => !!date ? moment(date).format('DD/MM/YYYY') : '-'


export default function ClaimsTable(props, context) {  
  const _navigateTo = (claim)  => {
    // var goTo = reverse('clients:detail:claim', {
    //   id: claim.client.user.uuid,
    //   vehicleId: claim.vehicle.id
    // })
    // var goTo = reverse('clients:detail:claimhistoric', {
    var goTo = reverse('clients:detailhistory:claimhistoric', {
      id: claim.client.user.uuid,
      vehicleId: claim.vehicle.id,
      claimId: claim.id
    })
    context.router.history.push(goTo)
  }

  const _validateStatus = (claim) => {
    if (!claim.policy){
      return
    }
    if(props.status === 'Course') {
      if(!!claim.is_active && !claim.is_closed) {
        return _renderClaim(claim)
      }
    } else if (props.status === 'Historic') {
      if(!claim.is_active && !!claim.is_closed) {
        return _renderClaim(claim)
      }
    } else if (props.status === 'Incomplete') {
      if(!claim.is_active && !claim.is_closed) {
        return _renderClaim(claim)
      }
    }

  }

  const _getDays = (claim, date) => {
    if(props.status === 'Course') {
      if(!!claim.is_active && !claim.is_closed) {
        var days = 0
        if (!!date) {
          var moment_date = moment(date)
          days = moment().diff(moment_date, 'days')
        }
        return days + ' días'
      }
    }
    return '-'
  }

  const _renderClaim = (claim) => {
    var claim_number = claim.number ? claim.number : '-'
    return (
        <tr onClick={() => _navigateTo(claim)} key={claim.id}>
          <td>
            <p>{claim.client.user.first_name} {claim.client.user.last_name}</p>
            <p className="small">{claim.client.user.email}</p>
          </td>
          <td>
            <p>{getBrandName(claim.vehicle)} {getModelName(claim.vehicle)}</p>
            <p>{getMakerName(claim.vehicle)}</p>
            <p className="small">{claim.vehicle.plates}</p>
            {!!claim.vehicle.alias && <p className="small">{claim.vehicle.alias}</p>}
          </td>
          <td>
            <p className="bold">{claim_number}</p>
            <p className="small break">{claim.policy.company} - <strong>Vendido por</strong> {claim.policy.broker}</p>
            <p>Póliza {claim.policy.number}</p>
          </td>
          <td>
            <p className="blue">{claim.type}</p>
          </td>
          <td>
            <p>{!!claim.workshop ? claim.workshop.name : null}</p>
          </td>
          <td>
            <p>{_parseDate(claim.activation_date)}</p>
            <p className="small">{_getDays(claim, claim.activation_date)}</p>
          </td>
          <td>
            <p>{_parseDate(claim.last_update)}</p>
            <p className="small">{_getDays(claim, claim.last_update)}</p>
          </td>
          <td>
            <p>{claim.last_update_message}</p>
          </td>
          <td>
            <p className="bold">{claim.updates_count}</p>
          </td>
        </tr>
    )
  }

  return (
    <div className="Claims__table">
      <table className="table table-stripped ">
        <thead>
          <tr>
            <th>Cliente</th>
            <th>Vehículo</th>
            <th>Siniestro</th>
            <th>Tipo</th>
            <th>Taller</th>
            <th>Fecha de inicio</th>
            <th>Fecha última actualización</th>
            <th>Contenido de última actualización</th>
            <th>#Actualizaciones</th>
          </tr>
        </thead>
        <tbody>
          {props.claims.map(_validateStatus)}
        </tbody>
      </table>
    </div>
  )
}

ClaimsTable.contextTypes = {
  router: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/scenes/Claims/components/Table/index.js